module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage ssTab1E"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("围绕本连续型电子"), _c('br'), _vm._v("出版物自行开设并运营"), _c('br'), _vm._v("的项目：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "业务网站(数据平台）"
    },
    model: {
      value: (_vm.params.operationProjectWeb),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWeb", $$v)
      },
      expression: "params.operationProjectWeb"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "专业数据库"
    },
    model: {
      value: (_vm.params.operationProjectDatabase),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectDatabase", $$v)
      },
      expression: "params.operationProjectDatabase"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "微信公众号"
    },
    model: {
      value: (_vm.params.operationProjectWechat),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWechat", $$v)
      },
      expression: "params.operationProjectWechat"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "小程序或APP"
    },
    model: {
      value: (_vm.params.operationProjectApp),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectApp", $$v)
      },
      expression: "params.operationProjectApp"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "微博"
    },
    model: {
      value: (_vm.params.operationProjectWeibo),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWeibo", $$v)
      },
      expression: "params.operationProjectWeibo"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "其他"
    },
    model: {
      value: (_vm.params.operationProjectOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectOther", $$v)
      },
      expression: "params.operationProjectOther"
    }
  }), _vm._v(" "), (_vm.params.operationProjectOther == '1') ? _c('el-input', {
    staticStyle: {
      "width": "240px",
      "margin-left": "5px"
    },
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入其他"
    },
    model: {
      value: (_vm.params.operationProjectOtherFill),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectOtherFill", $$v)
      },
      expression: "params.operationProjectOtherFill"
    }
  }) : _vm._e(), _c('br'), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "无"
    },
    model: {
      value: (_vm.params.operationProjectEmpty),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectEmpty", $$v)
      },
      expression: "params.operationProjectEmpty"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("\n            获取文章数字传播权主要方式：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "在期刊刊登声明，投稿即视为授权"
    },
    model: {
      value: (_vm.params.getGPLMethodSubmit),
      callback: function($$v) {
        _vm.$set(_vm.params, "getGPLMethodSubmit", $$v)
      },
      expression: "params.getGPLMethodSubmit"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "在投审稿平台予以提示，同意授权方可投稿"
    },
    model: {
      value: (_vm.params.getGPLMethodTip),
      callback: function($$v) {
        _vm.$set(_vm.params, "getGPLMethodTip", $$v)
      },
      expression: "params.getGPLMethodTip"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "与作者签订一对一的数字传播权授权合同"
    },
    model: {
      value: (_vm.params.getGPLMethodAuthor),
      callback: function($$v) {
        _vm.$set(_vm.params, "getGPLMethodAuthor", $$v)
      },
      expression: "params.getGPLMethodAuthor"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "其他",
      "true-label": "1",
      "false-label": "0"
    },
    model: {
      value: (_vm.params.getGPLMethodOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "getGPLMethodOther", $$v)
      },
      expression: "params.getGPLMethodOther"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "无"
    },
    model: {
      value: (_vm.params.getGPLMethodEmpty),
      callback: function($$v) {
        _vm.$set(_vm.params, "getGPLMethodEmpty", $$v)
      },
      expression: "params.getGPLMethodEmpty"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("数据平台建设和合作情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.params.databasePlatformOwner),
      callback: function($$v) {
        _vm.$set(_vm.params, "databasePlatformOwner", $$v)
      },
      expression: "params.databasePlatformOwner"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("自建")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '0'
    }
  }, [_vm._v("共建")])], 1), _vm._v(" "), (_vm.params.databasePlatformOwner == 1) ? _c('el-input', {
    staticStyle: {
      "width": "240px",
      "margin-left": "5px"
    },
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请填写平台名称"
    },
    model: {
      value: (_vm.params.databasePlatformName),
      callback: function($$v) {
        _vm.$set(_vm.params, "databasePlatformName", $$v)
      },
      expression: "params.databasePlatformName"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否与国际出版商开展合作：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.params.internationpublisher),
      callback: function($$v) {
        _vm.$set(_vm.params, "internationpublisher", $$v)
      },
      expression: "params.internationpublisher"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '0'
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.params.internationpublisher == 1) ? _c('el-input', {
    staticStyle: {
      "width": "240px",
      "margin-left": "5px"
    },
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请填写合作商名称"
    },
    model: {
      value: (_vm.params.internationpublisherName),
      callback: function($$v) {
        _vm.$set(_vm.params, "internationpublisherName", $$v)
      },
      expression: "params.internationpublisherName"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否被知名数据库收录：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.params.collectdatabase),
      callback: function($$v) {
        _vm.$set(_vm.params, "collectdatabase", $$v)
      },
      expression: "params.collectdatabase"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '0'
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.params.collectdatabase == 1) ? _c('el-input', {
    staticStyle: {
      "width": "240px",
      "margin-left": "5px"
    },
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请填写数据库名称"
    },
    model: {
      value: (_vm.params.collectdatabaseName),
      callback: function($$v) {
        _vm.$set(_vm.params, "collectdatabaseName", $$v)
      },
      expression: "params.collectdatabaseName"
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("人员情况")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位领导：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.zbSld),
      callback: function($$v) {
        _vm.$set(_vm.params, "zbSld", $$v)
      },
      expression: "params.zbSld"
    }
  })], 1), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("编辑人员：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.zbBjry),
      callback: function($$v) {
        _vm.$set(_vm.params, "zbBjry", $$v)
      },
      expression: "params.zbBjry"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("除编辑以外"), _c('br'), _vm._v("有关制作加工等"), _c('br'), _vm._v("相关人员：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumProcess),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumProcess", $$v)
      },
      expression: "params.pepnumProcess"
    }
  })], 1), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("专职发行人员：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumIssue),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumIssue", $$v)
      },
      expression: "params.pepnumIssue"
    }
  })], 1), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("其他人员"), _c('br'), _vm._v("（包括行政人员等）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumOther", $$v)
      },
      expression: "params.pepnumOther"
    }
  })], 1), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("总人数"), _c('br'), _vm._v("（以上6项合计）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumTotal),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumTotal", $$v)
      },
      expression: "params.pepnumTotal"
    }
  })], 1), _vm._v(" "), _c('br')], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.modifyFlag) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.submiting
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [(_vm.submiting) ? _c('span', [_vm._v("提交中")]) : _c('span', [_vm._v("保存")]), _vm._v(" "), (_vm.submiting) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("出版经营情况调查表")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29b4ed0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SPEC/ssBlock/forEdit/ssTab5.vue
// module id = 1700
// module chunks = 1